import "./Main.scss";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Outlet } from "react-router-dom";
import { useState } from "react";
import NavbarUserMenu from "../../components/NavbarUserMenu/NavbarUserMenu";
import { useMediaQuery } from "@mui/material";
import Sidebar from "../../components/Sidebar/Sidebar";
import useAdminPusher from "../../hooks/useAdminPusher";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Main = () => {
  useAdminPusher();
  const [open, setOpen] = useState(false);
  // Move the media query inside the component
  const isMobile = useMediaQuery("(max-width:767px)");
  const drawerWidth = isMobile ? 210 : 280;

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  // Create the AppBar styled component inside the component
  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginRight: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        sx={{
          background:
            "linear-gradient(89.51deg, #019aed -0.41%, #02e4d8 97.31%)",
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              margin: 0,
              padding: 0,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <div className="user-menu">
            <NavbarUserMenu />
          </div>
        </Toolbar>
      </AppBar>

      {/* Pass the drawer width to the Sidebar component */}
      <Sidebar
        open={open}
        handleDrawerClose={handleDrawerClose}
        drawerWidth={drawerWidth}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          padding: "30px 0px 30px 0px",
          backgroundColor: "#F7F9FB",
          overflow: "auto",
        }}
      >
        <DrawerHeader
          sx={{
            paddingTop: "60px",
            paddingRight: "30px",
            borderBottom: "1px solid  #E1E1E1",
          }}
        >
          <span style={{ width: "100%", fontSize: "14px", color: "#7A808A" }}>
            لوحة التحكم
          </span>
        </DrawerHeader>
        <div className="" style={{ minHeight: "100vh" }}>
          <Outlet />
        </div>
      </Box>
    </Box>
  );
};

export default Main;
